import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import '../../recap/src/globals.css';
import { AppContainer } from './AppContainer';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root container missing in index.html');
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <AppContainer />
  </StrictMode>,
);
